import { render, staticRenderFns } from "./DynamicSelect.vue?vue&type=template&id=a2165fc0&scoped=true"
import script from "./DynamicSelect.vue?vue&type=script&lang=js"
export * from "./DynamicSelect.vue?vue&type=script&lang=js"
import style0 from "./DynamicSelect.vue?vue&type=style&index=0&id=a2165fc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2165fc0",
  null
  
)

export default component.exports